import React, { Component } from 'react';
import { Input, Form, Modal, Button } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

const TextArea = Input.TextArea;
const FormItem = Form.Item;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};

const isRecordResolved = (rec) =>
    rec.resolved === true || rec.resolved === 1 || rec.resolved === 'true' || rec.resolved === '1';

class ResolveRuleReportModalDialog extends Component {
    onInputChange = ({ name, value }) => {
        this.props.resolveRuleReportChangeInput({ name, value });
    };

    submitResolveModal = () => {
        const { fields } = this.props.resolveModal;
        const { id, remarks, ruleReportRecord, selectedRecords } = fields;
        const recordsToUpdate = selectedRecords && selectedRecords.length > 0 ? selectedRecords : (ruleReportRecord ? [ruleReportRecord] : [{ id }]);
        const allResolved = recordsToUpdate.every(isRecordResolved);
        const count = recordsToUpdate.length;
        const confirmTitle = allResolved
            ? `Are you sure you want to update the Resolve Reason for ${count > 1 ? count + ' Rule Report records' : 'this Rule Report record'}?`
            : `Are you sure you want to mark ${count > 1 ? count + ' Rule Report records' : 'this Rule Report record'} as Resolved?`;
        Modal.confirm({
            title: confirmTitle,
            onOk: () => {
                const payloads = recordsToUpdate.map(rec => ({
                    ...rec,
                    resolved: true,
                    remarks: remarks,
                }));
                this.props.updateRuleReport(payloads);
            },
        });
    };


    render() {
        const { getFieldDecorator } = this.props.form;
        const { updateRuleReportActionStatus, resolveModal } = this.props;
        const { isOpened, fields } = resolveModal;
        const { remarks, selectedRecords } = fields;
        const isSubmitLoading = updateRuleReportActionStatus === ACTION_STATUS.LOGINING;
        const records = selectedRecords || [];
        const allResolved = records.length > 0 && records.every(isRecordResolved);
        const modalTitle = allResolved ? 'Edit Resolve Reason' : 'Resolve Rule Report';

        return (
            <Modal
                title={modalTitle}
                centered
                width={600}
                visible={isOpened}
                destroyOnClose={true}
                maskClosable={false}
                onCancel={() => this.props.closeResolveRuleReportModal()}
                footer={[
                    <Button key="Cancel" onClick={() => this.props.closeResolveRuleReportModal()}>
                        Cancel
                    </Button>,
                    <Button key="Submit" type="primary" loading={isSubmitLoading} onClick={this.submitResolveModal}>
                        Submit
                    </Button>,
                ]}
            >
                <Form layout="horizontal">
                    <FormItem {...formItemLayout} label="Resolve Reason">
                        {getFieldDecorator('remarks', {
                            initialValue: remarks,
                            rules: [{ required: false, message: '' }],
                        })(
                            <TextArea
                                style={{ width: '100%' }}
                                rows={4}
                                placeholder="Enter resolve reason"
                                onChange={e => this.onInputChange({ name: 'remarks', value: e.target.value })}
                            />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const ResolveRuleReportModalDialogForm = Form.create({ name: 'ResolveRuleReportModalDialog' })(ResolveRuleReportModalDialog);
export default ResolveRuleReportModalDialogForm;
